import { render, staticRenderFns } from "./TitleHorizontal.vue?vue&type=template&id=58821f7c"
import script from "./TitleHorizontal.vue?vue&type=script&lang=js"
export * from "./TitleHorizontal.vue?vue&type=script&lang=js"
import style0 from "./TitleHorizontal.vue?vue&type=style&index=0&id=58821f7c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports